module.exports = __webpack_public_path__ + "static/media/loader.df1d6354.svg";